import "./CheckoutPage.css";
import OrderSummaryComponent from "../../pages/Checkout/OrderSummary";
import { useState, useEffect } from "react";
import config from "../../config";
import checkout_bear from "../../images/checkout_bear.png";
import { useNavigate } from "react-router-dom";
import ShippingForm from "../Checkout/CheckoutPageComponents";
import { ShippingInfo } from "../../Interfaces/ShippingInfo";
import ShippingChoices from "../Checkout/ShippingChoices";
import { FundraiserResponse } from "../../Interfaces/Fundraiser";
import { useCart } from "../../contexts/Cart/CartContext";
import ContactForm, { ContactInfo } from "../Checkout/OrgShippingInfoForm";
import {
  calculateShippingCost,
  SHIP_TO_CUSTOMER,
  SHIP_TO_ORG,
  SHIP_TO_PARTICIPANT,
} from "../../CommonFunctions";
import RefactoredOrderSummary from "../Checkout/RefactoredOrderSummary";
import { ShippingAddressForm } from "../Checkout/ShippingAddress";
import RefactoredContactForm from "../Checkout/RefactoredContactForm";
import ScrollToTop from "../../layout/ScrollToTop";
const BASE_API = config.API_BASE_URL;

const RefactoredCheckoutPage = () => {
  const [fundraiser, setFundraiser] = useState<FundraiserResponse | null>(null);
  const [shippingChoice, setShippingChoice] =
    useState<string>(SHIP_TO_CUSTOMER);
  const navigate = useNavigate();
  const [freeShippingOptionSelected, setFreeShippingOptionSelected] =
    useState(false);
  const [shippingInfo, setShippingInfo] = useState<ShippingInfo>({
    ship_to_name: "",
    street_address: "",
    apt_suite: "",
    city: "",
    state: "",
    zip_code: "",
  });
  const [contactInfo, setContactInfo] = useState<ContactInfo>({
    full_name: "",
    email: "",
    phone: "",
  });
  const [isValidContactInfo, setIsValidContactInfo] = useState(false);
  const handleContinueShopping = () => {
    navigate("/checkout/cart"); //go back to the cart
  };
  const {
    state,
    freeShippingThreshold,
    baseShippingCost,
    freeShippingExceptions,
    baseShippingOverride,
    nonDonationItemTotal,
    nonDonationSubTotal,
  } = useCart();

  const shipToOrgAddress: ShippingInfo = {
    city: fundraiser?.org_shipping_info?.city || "",
    street_address: fundraiser?.org_shipping_info?.street_address || "",
    zip_code: fundraiser?.org_shipping_info?.zip_code || "",
    state: fundraiser?.org_shipping_info?.state || "",
    ship_to_name: fundraiser?.org_shipping_info?.ship_to_name || "",
  };

  const handleShippingChoiceChange = (choice: string) => {
    setShippingChoice(choice);
    if (choice === SHIP_TO_ORG) {
      setShippingInfo(shipToOrgAddress);
    } else {
      setShippingInfo({
        city: "",
        street_address: "",
        zip_code: "",
        state: "",
        ship_to_name: "",
      });
    }
  };

  useEffect(() => {
    const fetchFundraiser = async () => {
      try {
        const response = await fetch(
          `${BASE_API}fundraiser/${state.fundraiser_participant?.fundraiser}/detailed`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch fundraiser data");
        }
        const data: FundraiserResponse = await response.json();
        setFundraiser(data);
      } catch (error) {
        console.error("Error fetching fundraiser data:", error);
      }
    };

    fetchFundraiser();

    document.title = "Checkout";
  }, []);

  if (freeShippingThreshold === null) {
    return <div>Loading...</div>;
  }

  const shippingCost = calculateShippingCost(
    shippingInfo.state,
    nonDonationItemTotal,
    freeShippingThreshold,
    baseShippingCost,
    nonDonationSubTotal,
    freeShippingExceptions,
    baseShippingOverride,
    shippingChoice
  );

  return (
    <div>
      <div className="checkout-page-shipping-form-and-order-summary-container">
        <ScrollToTop />
        <div className="checkout-page-shipping-form-and-headers">
          <div className="checkout-page-header-and-image">
            <div className="checkout-page-header-text">
              <div className="checkout-page-continue-shopping">
                <span
                  onClick={handleContinueShopping}
                  className="checkout-page-continue-shopping-link"
                >
                  &lt; Back to cart
                </span>
              </div>

              <span className="checkout-page-horizontal-bar "></span>
              <div className="checkout-page-shipping-header">Checkout</div>
            </div>
            <img
              src={checkout_bear}
              alt="Bear Icon"
              className="checkout-page-checkout-image"
            />
          </div>
          <div className="checkout-page-shipping-form">
            <RefactoredContactForm
              setIsValidContactInfo={setIsValidContactInfo}
              setContactInfo={setContactInfo}
              contactInfo={contactInfo}
            />
          </div>
          {nonDonationItemTotal > 0 && shippingChoice === SHIP_TO_CUSTOMER && (
            <div className="checkout-page-shipping-form">
              <ShippingAddressForm
                setShippingInfo={setShippingInfo}
                shippingInfo={shippingInfo}
              />
            </div>
          )}
        </div>
        <div className="checkout-page-summary-shipping-container">
          {fundraiser !== null && (
            <div className="checkout-page-shipping-choices">
              <ShippingChoices
                shippingChoice={shippingChoice}
                onShippingChoiceChange={handleShippingChoiceChange}
                fundraiser={fundraiser}
              />
            </div>
          )}
          <div className="checkout-page-order-summary">
            {fundraiser !== null && (
              <RefactoredOrderSummary
                onShippingStep={true}
                shippingOption={shippingChoice}
                shippingInfo={shippingInfo}
                setShippingInfo={setShippingInfo}
                contactInfo={contactInfo}
                shippingCost={shippingCost}
                isValidContactInfo={isValidContactInfo}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefactoredCheckoutPage;
